<script>
import Badge from '@/components/molecules/Badge'
import { mapGetters } from 'vuex'

export default {
    name: 'GoToCheckout',
    components: { Badge },
    props: {
        checkoutDisabled: null,
        goToCheckout: null,
        currency: null,
        price: null,
        originalPrice: null,
        subTotal: null,
        minimumOrder: null,
    },
    computed: {
        ...mapGetters(['lgDevice', 'smDevice']),
    },
}
</script>

<template lang="pug">
.go-to-checkout.d-flex.flex-wrap.justify-content-center
    .payment-line.w-100.order-1(v-if="price > 0 && smDevice && currency")
        span.font-weight-semibold {{$t('order.total')}}
        span.font-weight-semibold {{price | toCurrency(currency.locale, currency.currency_code)}}
    button.btn.btn-primary.btn-block.btn-lg.btn-currency.justify-content-center.justify-content-md-between.order-2.order-md-0(:disabled="checkoutDisabled" @click="goToCheckout()")
        span {{$t('cart.goto_checkout')}}
        .d-flex.flex-column(v-if="lgDevice")
            s.font-size-sm(v-if="originalPrice !== price && originalPrice && currency") {{originalPrice | toCurrency(currency.locale, currency.currency_code)}}
            span(v-if="price >= 0 && currency && currency.locale") {{price | toCurrency(currency.locale, currency.currency_code)}}
    template(v-if="minimumOrder && (subTotal < minimumOrder) && currency" )
        badge.mb-4.mb-md-0.mt-md-4.order-0.order-md-1(v-if="minimumOrder > subTotal && subTotal > 0" type="warning" pill)
            | {{ minimumOrder - subTotal | toCurrency(currency.locale, currency.currency_code)}} {{$t('cart.till_minimum_order') }}
        p.body-m.text-73.my-4.mb-md-0.order-0.order-md-1(v-else)
            | {{ minimumOrder | toCurrency(currency.locale, currency.currency_code)}} {{$t('cart.minimum_order') }}
</template>
